import { apiGet, apiPost } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getKioskSettingsAPI = () => {
  return apiGet('plugins/settings/kiosk')
}

export const saveKioskSettingsAPI = (data) => {
  Hotjar.event('save_kios_setting')

  return apiPost('plugins/settings/kiosk', data)
}



// WEBPACK FOOTER //
// ./src/api/kioskSettings.js